import cx from "classnames";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { getContrastColor } from "@/canv/utils";
import { STICKER_COLORS } from "@/elements/sticker";
import { stickerToolMenuColor } from "@/interface/AppStore";
import CheckIcon from "../../../icons/CheckIcon.svg?react";
import styles from "./StickerMenu.module.css";

export const StickerMenu = () => {
    const stickerColor = useAtomValue(stickerToolMenuColor);

    const handleSelectColor = (color: string) => {
        canv.toolBox.Tools.stickerTool.setColor(color);
    };

    return (
        <div className={styles.stickerToolSubMenu}>
            {STICKER_COLORS.map((color) => {
                const contrastColor = getContrastColor(color);

                return (
                    <button
                        key={color}
                        type="button"
                        data-sticker-color={color}
                        data-sticker-text-color={contrastColor}
                        className={cx(styles.stickerToolColorButton, {
                            [styles.stickerToolColorButtonSelected]: color === stickerColor,
                        })}
                        onClick={() => handleSelectColor(color)}
                    >
                        <span
                            className={styles.stickerToolColorBox}
                            style={{ backgroundColor: color, color: contrastColor }}
                        >
                            <CheckIcon />
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
